<template>
  <el-scrollbar wrapClass="scrollbar-wrapper">
    <el-menu
      class="sidebar-menu"
      mode="vertical"
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="isCollapse"
      :background-color="bg"
      :text-color="tc"
      :unique-opened="true"
      active-text-color="#000"
      data-old-padding-bottom="50px;"
      @open="open"
      @close="close"
    >
      <sidebar-item :routes="permission_routers" :userType="userType" :areaList="areaList" :tit="activeTit"></sidebar-item>
    </el-menu>
  </el-scrollbar>
</template>

<script>
import { mapGetters } from 'vuex'
import sidebarItem from './SidebarItem'

export default {
  name: 'Sidebar',
  data() {
    return {
      bg: '#2E303C',
      tc: 'rgba(255,255,255,.6)',
      atc: '#fff', //,'#20232C',
      activeTit: ''
    }
  },
  components: {
    sidebarItem
  },
  computed: {
    ...mapGetters(['sidebar', 'permission_routers']),
    ...mapGetters(['sidebar', 'userType']),
    ...mapGetters(['sidebar', 'areaList']),
    isCollapse() {
      if (this.sidebar.sliderState === 'full') {
        return false
      }
      return true
    }
  },
  methods: {
    open(arr) {
      let tit = arr
      let that = this
      that.activeTit = tit
    },
    close() {
      let that = this
      that.activeTit = ''
    }
  }
}
</script>
<style>
/* .el-menu.el-menu--inline {
  padding-bottom: 50px !important;
} */
</style>

